import React from 'react'
import './SearchInput.css';

const SearchInput = ({ onChange, value, placeholder }) => {
    return (
        <section className="help-search-section">
            <div className="help-search-container">
                <input
                    type="text"
                    placeholder={placeholder}
                    className="help-search-input"
                    value={value}
                    onChange={onChange}
                />
                <span className="help-search-icon">🔍</span>
            </div>
        </section>
    )
}

export default SearchInput;